module.exports = [{"uvId":1,"uvLibelle":"ML"},{"uvId":2,"uvLibelle":"m²"},{"uvId":3,"uvLibelle":"U"},{"uvId":4,"uvLibelle":"ENS"},{"uvId":5,"uvLibelle":"FT"}]


//////////////////
// WEBPACK FOOTER
// ./src/services/unites/datas.json
// module id = 573
// module chunks = 0